import React from "react";
import Header from "./components/Header/Header";
import "./common/styles/main.scss";
import Main from "./components/Main/Main";
import Footer from "./components/Footer/Footer";
import Sidebar from "./components/Sidebar/Sidebar";
import WorkExperience from "./pages/WorkExperience/WorkExperience";
import Home from "./pages/Home/Home";
import Youtube from "./pages/Youtube/Youtube";
import WhoAmI from "./pages/WhoAmI/WhoAmI";
import Projects from "./pages/Projects/Projects";
var App = function () { return (React.createElement("div", { className: "app-container" },
    React.createElement(Header, null),
    React.createElement(Main, null,
        React.createElement(Home, null),
        React.createElement(WhoAmI, null),
        React.createElement(WorkExperience, null),
        React.createElement(Projects, null),
        React.createElement(Youtube, null)),
    React.createElement(Sidebar, null),
    React.createElement(Footer, null))); };
export default App;
